<div>
    <div>
        <div>
            <!--<app-audi-text variant="copy1" weight="normal" text="Please start a WebChat to chat to an agent."> </app-audi-text>
            <br /><br />-->
            <!--<app-audi-button text="Start WebChat" (click)="onWebChat()"></app-audi-button>-->
            <!--<br /><br />-->
            <app-audi-text variant="copy1" weight="normal" text="Please provide your details in the form below, and we will contact you thereafter.">
            </app-audi-text><br /><br />
            <form [formGroup]="contactUsForm">
                <div>
                    <app-audi-text-input inputId="contact-us-firstName" label="First Name*" isRequired="true" formControlName="firstName"
                        (onblur)="onValidateInput('firstName',null)" (valueChange)="onValidateInput('firstName',$event)" [validationMessage]="validatedFields['firstName']">
                    </app-audi-text-input>
                </div>
                <div>
                    <app-audi-text-input inputId="contact-us-lastName" label="Last Name*" isRequired="true" formControlName="lastName" (onblur)="onValidateInput('lastName',null)"
                        (valueChange)="onValidateInput('lastName',$event)" [validationMessage]="validatedFields['lastName']">
                    </app-audi-text-input>
                </div>
                <div>
                    <app-audi-text-input inputId="contact-us-contactNumber" label="Contact Number*" isRequired="true" formControlName="contactNumber"
                        (onblur)="onValidateInput('contactNumber',null)" (valueChange)="onValidateInput('contactNumber',$event)"
                        [validationMessage]="validatedFields['contactNumber']">
                    </app-audi-text-input>
                </div>
                <div>
                    <app-audi-text-input inputId="contact-us-emailAddress" label="Email Address*" isRequired="true" formControlName="emailAddress"
                        (onblur)="onValidateInput('emailAddress',null)" (valueChange)="onValidateInput('emailAddress',$event)"
                        [validationMessage]="validatedFields['emailAddress']">
                    </app-audi-text-input>
                </div>
                <div>
                    <app-audi-text-input inputId="contact-us-message" label="Message*" isRequired="true" formControlName="message" rows="2"
                        (onblur)="onValidateInput('message',null)" (valueChange)="onValidateInput('message',$event)" [validationMessage]="validatedFields['message']">
                    </app-audi-text-input>
                </div>
                <div style="margin-top:10px;margin-bottom:10px;">
                    <app-audi-text variant="copy2" text="* Indicates required fields"></app-audi-text>
                </div>
                <ng-hcaptcha (verify)="onVerifyCaptcha($event)" (expired)="onCaptchaExpired($event)" (error)="onCaptchaError($event)"></ng-hcaptcha><br />
                <app-audi-button text="Submit" (click)="onSubmit()" [disabled]="!contactUsForm.valid"></app-audi-button>
            </form>
        </div>
        <!--loading spinner-->
        <div [hidden]="!loaderVisible" style="width:100%;height:100%;background-color:#808080;opacity:0.25;position:absolute;top:0;left:0;right:0;margin:auto;z-index:10000;">
        </div>
        <div [hidden]="!loaderVisible" style="position:absolute;top:45%;left:45%;z-index:12000;">
            <app-audi-loader></app-audi-loader>
        </div>
    </div>
</div>
